
import React from "react";
import EmptyCartImg from "../../../assets/EmptyCart.png";

const EmptyCart = () => {
  return (
    <div className="flex flex-col items-center w-full min-h-[60vh] justify-center px-4">
      {/* Main Content Container */}
      <div className="bg-white rounded-[24px] shadow-2xl border border-gray-100 p-8 lg:p-12 max-w-[600px] w-full text-center">
        {/* Title */}
        <div className="font-[800] text-[24px] lg:text-[32px] leading-[32px] lg:leading-[40px] text-[#183864] mb-6">
          Your Cart is Empty
        </div>
        
        {/* Subtitle */}
        <div className="text-[#9A9EA6] text-[16px] lg:text-[18px] leading-[24px] font-[500] mb-8">
          Looks like you haven't added any items to your cart yet. 
          <br className="hidden lg:block" />
          Explore our products and find something you love!
        </div>
        
        {/* Empty Cart Image */}
        <div className="mb-8 flex justify-center">
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-br from-[#E9EFFF] to-[#F5F8FF] rounded-full blur-3xl opacity-60 scale-110"></div>
            <img 
              src={EmptyCartImg} 
              alt="Empty Cart" 
              className="relative w-[280px] h-[250px] lg:w-[338px] lg:h-[300px] object-contain drop-shadow-lg"
            />
          </div>
        </div>
        
        {/* Action Buttons */}
        <div className="space-y-4">
          {/* Primary Button */}
          <button className="bg-gradient-to-r from-[#B02526] to-[#8B1E1F] hover:from-[#8B1E1F] hover:to-[#B02526] w-full lg:w-[320px] h-[48px] lg:h-[56px] rounded-[12px] flex items-center justify-center text-white font-[700] text-[16px] lg:text-[18px] leading-[28.8px] cursor-pointer transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105 mx-auto">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mr-2">
              <path d="M7 4V2C7 1.45 7.196 0.979 7.588 0.588C7.98 0.197 8.45 0.000666667 9 0H15C15.55 0 16.021 0.196 16.413 0.588C16.805 0.98 17.0007 1.45 17 2V4H20C20.2833 4 20.521 4.096 20.713 4.288C20.905 4.48 21.0007 4.71733 21 5C21 5.28333 20.904 5.521 20.712 5.713C20.52 5.905 20.2827 6.00067 20 6H19V19C19 19.55 18.804 20.021 18.412 20.413C18.02 20.805 17.5493 21.0007 17 21H7C6.45 21 5.979 20.804 5.587 20.412C5.195 20.02 4.99933 19.5493 5 19V6H4C3.71667 6 3.479 5.904 3.287 5.712C3.095 5.52 2.99933 5.28267 3 5C3 4.71667 3.096 4.479 3.288 4.287C3.48 4.095 3.71733 3.99933 4 4H7ZM9 2V4H15V2H9ZM7 6V19H17V6H7Z" fill="currentColor"/>
            </svg>
            Start Shopping
          </button>
          
          {/* Secondary Button */}
          <button className="border-2 border-[#B02526] text-[#B02526] hover:bg-[#B02526] hover:text-white w-full lg:w-[320px] h-[44px] lg:h-[48px] rounded-[12px] flex items-center justify-center font-[600] text-[14px] lg:text-[16px] leading-[24px] cursor-pointer transition-all duration-300 mx-auto">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mr-2">
              <path d="M12 2L13.09 8.26L22 9L13.09 9.74L12 16L10.91 9.74L2 9L10.91 8.26L12 2Z" fill="currentColor"/>
            </svg>
            View Featured Items
          </button>
        </div>
        
        {/* Help Text */}
        <div className="mt-8 pt-6 border-t border-gray-100">
          <div className="text-[#9A9EA6] text-[14px] leading-[20px] font-[500]">
            Need help finding what you're looking for?
          </div>
          <div className="text-[#B02526] text-[14px] leading-[20px] font-[600] cursor-pointer hover:underline mt-1">
            Contact our support team
          </div>
        </div>
      </div>
    </div>
  )
}
export default EmptyCart;
